import React from 'react';
import { OWNER_ENGINEER_WARNING_MSG } from '../helpers/ownerEngineerValidation';

const OwnerEngineerWarning = ({ onClose, onUploadDocument }) => {
  return <p>{OWNER_ENGINEER_WARNING_MSG}</p>;
};

export default OwnerEngineerWarning;
